const { CLEVER_CONFIG } = require("./clever");
const { KLIAN_CONFIG } = require("./klian");

const brand = process.env.NEXT_PUBLIC_THEME;

const config = {
    klian: {
        name: 'klian',
        config: KLIAN_CONFIG
    },
    clever: {
        name: 'clever',
        config: CLEVER_CONFIG
    }
};

const brandConfig = () => {
    return config[brand];
};

module.exports = brandConfig;
